import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import styles from "../ItemsBlock/ItemsBlock.module.scss";
import Items from "../Items/Items";

interface Item {
    id: string | number;
    title: string;
    url?: string;
    menu?: [];
}

interface BoxProps {
    handleLinkClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, url: string, target?: string, isInternalLink?: boolean) => void;
    items: Item[];
    className?: string;
}

const Box: React.FC<BoxProps> = ({ items, handleLinkClick, className }) => {
  return (
    <div className={cn(styles.box, className)}>
      <div className={styles.leftBox}>
        <Items list={items.slice(0, 6)} handleLinkClick={handleLinkClick} />
      </div>
      {items.length > 6 && (
        <div className={styles.rigthBox}>
          <Items list={items.slice(6)} handleLinkClick={handleLinkClick} />
        </div>
      )}
    </div>
  );
};

Box.propTypes = {
  handleLinkClick: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  className: PropTypes.string
};

Box.defaultProps = {
  className: ""
};

export default Box;
